import { Outlet } from "react-router-dom";
import Sidebar from "../UI/Sidebar";

const Layout1 = () => {
    return (
        <div className="dash-wrap flex items-center h-screen py-4 pr-4 fixed w-full">
            <div className="side-bar">
                <Sidebar />
            </div>
            <div className={`app-content w-full h-full overflow-y-scroll px-6`}>
                <Outlet />
            </div>

        </div>
    )
}

export default Layout1;